import { logTrackingError } from './utils';

/**
 * Validate the data we will be sending with an event.
 * NOTE: The only validation at the moment, is that all properties defined
 * should be defined.
 */
export function validateEventData(eventName: string, properties: Array<unknown>): boolean {
  const invalid = properties.some((prop) => prop === undefined || prop === null);

  // If invalid show console error.
  // NOTE: We don't throw an error intentionally,
  // as we don't want metrics issues to impact user experience.
  if (invalid) {
    logTrackingError(`${eventName} -- One or more required properties are missing.`);
    return false;
  }

  return true;
}
